import { Alert, AlertIcon, Box, Code, Heading, Stack, Text } from "@chakra-ui/react";
import {
  variableNamesFor,
  type EmailTemplateVocabulary,
} from "../api/emailTemplateVars";
import { isLinkVariable, linkSentinel } from "../lib/linkVariables";

/**
 * The variables THIS template receives — not every variable that exists.
 * Showing the full list invites reaching for one from another lane, which
 * renders blank in the real email.
 */
export default function JinjaTagHelp({
  catalog,
  templateName,
}: {
  catalog: EmailTemplateVocabulary | null;
  templateName: string | null;
}) {
  if (!catalog) {
    return (
      <Box borderWidth="1px" borderRadius="md" p={3}>
        <Heading size="sm" mb={2}>
          Available tags
        </Heading>
        <Alert status="warning" fontSize="xs" borderRadius="md">
          <AlertIcon />
          Variable list unavailable — tags aren&apos;t being checked.
        </Alert>
      </Box>
    );
  }

  const allowed = new Set(variableNamesFor(catalog, templateName));
  const shown = catalog.variables.filter((v) => allowed.has(v.name));

  return (
    <Box borderWidth="1px" borderRadius="md" p={3} maxH="480px" overflowY="auto">
      <Heading size="sm" mb={1}>
        Available tags
      </Heading>
      <Text fontSize="xs" color="gray.500" mb={2}>
        {templateName
          ? `Delivered to “${templateName}”`
          : "Delivered to every template"}
      </Text>
      <Text fontSize="xs" color="gray.500" mb={2}>
        To make a word link to one of these, Google Docs won&apos;t accept{" "}
        <Code fontSize="xs">{"{{ … }}"}</Code> as a link — use the{" "}
        <Code fontSize="xs">https://</Code> form shown below instead. It is
        converted on upload. An unrecognized one is rejected, not sent.
      </Text>
      <Stack spacing={2}>
        {shown.map((tag) => (
          <Box key={tag.name}>
            <Code fontSize="xs">{`{{ ${tag.name} }}`}</Code>
            {isLinkVariable(tag.name) && (
              <Code fontSize="xs" ml={1} colorScheme="purple">
                {linkSentinel(tag.name)}
              </Code>
            )}
            <Text fontSize="xs" color="gray.500">
              {tag.description}
            </Text>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
